import { render } from "./ModalValidation.vue?vue&type=template&id=20e58ecb"
import script from "./ModalValidation.vue?vue&type=script&lang=js"
export * from "./ModalValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__